import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { FlagsmithProvider } from "flagsmith/react";
import flagsmith from "flagsmith";
import { PageContainer } from "./layouts/page-container";
import { UseTrackPageView } from "./features/analytics/utils/trackPageView";
import { AuthGuard } from "./components/auth-guard";
import { RouteFallback } from "./components/route-fallback";
import { Toaster } from "./components/ui/toaster";

export const App = () => {
  UseTrackPageView();

  return (
    <FlagsmithProvider
      flagsmith={flagsmith}
      options={{
        environmentID: import.meta.env.VITE_FLAGSMITH_ENVIRONMENT_KEY || "",
        enableAnalytics: false,
        preventFetch: false,
        cacheFlags: true,
        enableLogs: import.meta.env.DEV,
      }}
    >
      <AuthGuard>
        <PageContainer>
          <Suspense fallback={<RouteFallback />}>
            <Outlet />
          </Suspense>
        </PageContainer>
        <Toaster />
      </AuthGuard>
    </FlagsmithProvider>
  );
};
